import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{yield this.matchingCollection}}", {
  moduleName: "@dashboard/shared-ui/components/filter-collection.hbs"
});